import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
//

import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import { Typography } from '@mui/material';
import MobileBottomBar from '../Components/mobileBottomBar';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  // backgroundColor:'#fafafa',
  display: 'flex',
  minHeight: '50%',
  overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  
  //paddingTop: APP_BAR_MOBILE,
  //paddingBottom: theme.spacing(0),
  [theme.breakpoints.up('lg')]: {
    //paddingTop: APP_BAR_DESKTOP ,
  }
}));

// ----------------------------------------------------------------------

export default function Layout() {
  const [open, setOpen] = useState(false);

  return (
    <RootStyle>
      {/* <DashboardNavbar onOpenSidebar={() => setOpen(true)} />*/}
      <MainStyle>
        {/**<Typography>Salut</Typography> */}
        <Navbar />
        <Outlet />
        {/* Bottom bar mobile only */}
      <MobileBottomBar />
      </MainStyle>
    </RootStyle>
  );
}
